module.exports = __webpack_public_path__ + "static/media/FABIO.5456aca4.JPG";